import { h } from "preact";

/**
 * Карточка с заголовком и телом.
 * Используется для всех секций калькулятора.
 *
 * Пропсы:
 *   title    — заголовок
 *   classes  — внешние классы для сетки (w-full md:w-1/3 и т.п.)
 *   children — содержимое тела
 */
export function Island({ title, classes = "", children }) {
  return h("div", { class: "sm:px-4 sm:mb-4 " + classes },
    h("div", { class: "island" },
      h("h3", { class: "island__title" }, title),
      h("div", { class: "island__body" }, children)
    )
  );
}
